import { cn } from '@/utils'
import {
  type PlacementDragGhostProps,
  dragGhostPosition,
} from '@/components/app/placement/placement-drag-ghost'

type ColorDragGhostProps = Omit<PlacementDragGhostProps, 'imageUrl' | 'label'> & {
  /** CSS color value to fill the swatch with. */
  color: string
}

/** A fixed-size colored swatch that follows the pointer while dragging a fill color swatch. */
export function ColorDragGhost({
  color,
  clientX,
  clientY,
  width,
  height,
  opacity,
  overCanvas,
  overFillTarget,
  keyboardCarry,
  flyback = false,
  thumbOrigin,
}: ColorDragGhostProps) {
  const { left, top } = dragGhostPosition({
    clientX,
    clientY,
    width,
    height,
    keyboardCarry,
    flyback,
    thumbOrigin,
  })

  return (
    <div
      className={cn(
        'pointer-events-none fixed z-[9999] rounded-md border-2 shadow-lg',
        flyback
          ? 'transition-all duration-200 ease-out'
          : 'transition-[border-color,box-shadow] duration-100',
        overFillTarget ? 'border-green-600' : overCanvas ? 'border-primary/60' : 'border-border'
      )}
      style={{
        left,
        top,
        width,
        height,
        opacity,
        backgroundColor: color,
        boxShadow: overFillTarget ? '0 0 12px rgba(22,163,74,0.5)' : undefined,
      }}
      aria-hidden
    />
  )
}
